import type {IAppDispatch, IRootState} from "../../store/store";
import {
    IRegistrationFlowUserState,
    IStartRegistrationFlowPayload,
    startRegistrationFlow,
    startRegistrationFlowByVariant
} from "../state/registration_flow_slice";
import {RegistrationFlowControlAction} from "../types/RegistrationFlowControlAction";
import {selectRegistrationFlowUserState} from "../utils/select_registration_flow_user_state";

export type RegistrationFlowForCurrentUser = Omit<IStartRegistrationFlowPayload, keyof IRegistrationFlowUserState | "flowVariant" | "controlAction">;

export const startRegistrationFlowForCurrentUser =
    (flow: RegistrationFlowForCurrentUser, controlAction?: RegistrationFlowControlAction) => (dispatch: IAppDispatch, getState: () => IRootState) => {
        const {isUserLoggedIn, hasCompleteProfile, hasPhoneVerified, hasPhone, hasName} = selectRegistrationFlowUserState(getState());

        if (controlAction) {
            dispatch(startRegistrationFlowByVariant({isUserLoggedIn, hasCompleteProfile, hasPhoneVerified, hasPhone, hasName, ...flow}, controlAction));
            return;
        }

        dispatch(startRegistrationFlow({isUserLoggedIn, hasCompleteProfile, hasPhoneVerified, ...flow}));
    };
import type {IAppDispatch, IRootState} from "../../store/store";
import {
    IRegistrationFlowUserState,
    IStartRegistrationFlowPayload,
    startRegistrationFlow,
    startRegistrationFlowByVariant
} from "../state/registration_flow_slice";
import {RegistrationFlowControlAction} from "../types/RegistrationFlowControlAction";
import {selectRegistrationFlowUserState} from "../utils/select_registration_flow_user_state";

export type RegistrationFlowForCurrentUser = Omit<IStartRegistrationFlowPayload, keyof IRegistrationFlowUserState | "flowVariant" | "controlAction">;

export const startRegistrationFlowForCurrentUser =
    (flow: RegistrationFlowForCurrentUser, controlAction?: RegistrationFlowControlAction) => (dispatch: IAppDispatch, getState: () => IRootState) => {
        const {isUserLoggedIn, hasCompleteProfile, hasPhoneVerified, hasPhone, hasName} = selectRegistrationFlowUserState(getState());

        if (controlAction) {
            dispatch(startRegistrationFlowByVariant({isUserLoggedIn, hasCompleteProfile, hasPhoneVerified, hasPhone, hasName, ...flow}, controlAction));
            return;
        }

        dispatch(startRegistrationFlow({isUserLoggedIn, hasCompleteProfile, hasPhoneVerified, ...flow}));
    };
